a<template>
<div id="container" class="junglegeschichten">
    <div class="fullscreen_background">
        <img src="/static/assets/junglegeschichten/Jungle_2880zu1620_2105.png" />
    </div>
    <top-menu />
    <top-logo />
    <stoppuhr />
    <lautsprecher />
    <copyright />
    <hintergrundbutton />
    <div class="kolibri z40 hovering">
        <img class="img" src="/static/assets/junglegeschichten/Kolibri.png" />
    </div>
    <div class="baer z30">
        <img class="img" src="/static/assets/junglegeschichten/Baer.png" />
    </div>
    <div class="lianen_joe z30">
        <img class="img" src="/static/assets/junglegeschichten/Lianen_Joe.png" />
    </div>
    <div class="libero z30">
        <img class="img" src="/static/assets/junglegeschichten/Libero.png" />
    </div>
    <div class="hugi z30">
        <img class="img" src="/static/assets/junglegeschichten/Hugi.png" />
    </div>
    <div class="dubix z30">
        <img class="img" src="/static/assets/junglegeschichten/Dubix.png" />
    </div>
	   <div class="Uhu z40 uhu_animation" v-bind:class="{uhu_animation:animateUhu}" v-on:click="aktiviereUhu">
    </div>
		<div class="gigi z30">
        <img class="img" src="/static/assets/junglegeschichten/Gigi.png" />
    </div>
    <div class="wasserfall wasserfall_animation z29 pointer" v-bind:class="{wasserfall_animation:animateWasser}" v-on:click="aktiviereWasser">
    </div>
    <router-link to="/wassergeschichten" tag="div" class="pfeil_links_big z50 pointer">
        <img class="img" src="/static/assets/zaubergeschichten/Pfeil.png" />
    </router-link>

    <router-link to="/spacegeschichten" tag="div" class="pfeil_rechts_big z50 pointer">
        <img class="img" src="/static/assets/zaubergeschichten/Pfeil-1.png" />
    </router-link>

    <div class="geschichte z50">
        <img src="/static/assets/junglegeschichten/Geschichte.png" usemap="#geschichte-map">
        <player audiourl="https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Geschichte_3_Hugi_Forscher.mp3" jsonurl="/static/assets/geschichten/hugi_19_3.timings.json" content=".junglegeschichten" target="junglegeschichten_target"/>
        <!-- // eslint-disable-next-line -->
      <vuescrollbar tag="div" class="fliesstext" id="junglegeschichten_target">
        <p>Die Expeditionstruppe kam ganz schön ins Schwitzen. Besonders Hugi Forscher, der mit der Machete voranging und für die Nachfolgenden den Weg durch das Dschungeldickicht frei schlug. Plötzlich hielt er inne. „Stopp!“, rief er mit gesenkter Stimme. Stumm winkte er Dubix Zoologus, Gigi Jones und Libero Koko heran. „Seht euch das an!“, flüsterte er und deutete nach vorne. Da lag ein Bärenkind im Unterholz verborgen in einem Blätterbett. Es rührte sich kaum und stöhnte nur: „Aua, aua!“</p>
<p>„Wooaaa!“ Mit einem Mal stand aufgerichtet eine riesige Bärin vor ihnen und brüllte sie drohend an. Die vier Hugidubies blieben wie angewurzelt stehen und rührten sich nicht vom Fleck, „Aua, aua“, wimmerte das Bärchen. Voller Sorge wandte sich die Bärin ihrem Kind zu, tröstete es und vergaß die Eindringlinge. Vorsichtig näherte sich Hugi Forscher den beiden und fragte mitleidig: „Was hast du denn, Kleines, was tut dir weh?“ „Bärchen Lalu hat Bauchweh. Ich kann ihm nicht helfen.“, schluchzte seine Mutter, die Vertrauen zu den Hugidubies fasste und sich als Mama Bär vorstellte. Hugi Forscher konnte es nicht glauben. Monatelang waren sie schon im Dschungel unterwegs, um die sprechenden Tiere zu suchen, und jetzt hatten sie sie gefunden. Doch nun war keine Zeit, sich darüber zu freuen, er musste Bärchen Lalu helfen. Aufgeregt zog er aus seinem Rucksack ein Medizinbuch und blätterte darin. „Setzt euch und gebt mir ein wenig Zeit“, sagte er.</p>
<p>„Rhabarberwurzel-Wickel!“, rief er einige Zeit später und sprang auf. „Rhabarberwurzel-Wickel! Die werden Bärchen Lalu helfen!“ Doch oje! Wo wuchs hier im Dschungel Rhabarber? „Der Uhu Tschu weiß es bestimmt!“, rief Mama Bär und brüllte markerschütternd laut: „Tschuuuuu!“ Schon flatterte es über ihren Köpfen und Tschu landete auf Mama Bärs Schulter. Gerne erklärte sich der Uhu bereit, den Hugidubies den Weg zum Rhabarber zu zeigen. „Er ist aber weit und gefährlich. Ihr braucht einen Dschungelführer.“ Sprach’s und rief laut: „Joeuu, Joeuu!“ Schuuummm — schon sahen sie einen Affen, der sich an einer Liane festhielt und durch die Bäume auf sie zuflog. „Das ist Lianen-Joe“, stellte der Uhu Tschu den Affen vor, „er wird euch zeigen, wie man im Dschungel am schnellsten vorwärtskommt.“ </p>
<p>Bald darauf kletterte Lianen-Joe mit den Hugidubies auf den nächsten Baum und nun schwangen sie sich mit Libero Koko im Rucksack von Liane zu Liane. Oben am Himmel flog Tschu und zeigte ihnen den Weg. Mit einem Affenzahn ging’s durch den Dschungel. Bis sie zu einem mächtigen Wasserfall kamen. Wie sollten sie den überqueren? „Tschuuuu!“, rief Dubix Zoologus und blickte zum Himmel. „Uuuu!“, heulte Libero. Doch da war kein Tschu mehr zu sehen. „Tschuuuu!“, schrien alle zusammen. Kein Tschu weit und breit. „Wir müssen weiter, die Zeit drängt, Bärchen Lalu hat solche Schmerzen!“, jammerte Gigi Jones. „Wir müssen einen Weg finden!“ „Es gibt keinen“, raunte Lianen-Joe traurig. „Wir können Lalu nicht helfen!“ Plötzlich hörten sie Vogelrufe am Himmel. Tschu war zurück und mit ihm eine ganze Adlerfamilie. Die griffen sich die Hugidubies und Lianen-Joe und trugen sie durch die Lüfte über den wild rauschenden Wasserfall hinweg bis zu der Stelle, wo der Rhabarber wuchs. </p>
<p>Schnell grub Libero Koko eine Rhabarberwurzel aus. Zusammen brachten die Freunde sie zur Bärenfamilie und machten dem Bärenkind einen Rhabarberwurzel-Wickel. Schon am Abend hatte Bärchen Lalu kein Bauchweh mehr. Es saß mit seiner Mama am Lagerfeuer der Hugidubies und Dubix Zoologus las ihm eine Gutenachtgeschichte vor. Als seine Mama es später ins Blätterbett brachte, konnte es kaum mehr die Augen aufhalten. Wohlig murmelte es in die Traumwelt hinein: </p>
<p><span>Das Lesen ist schön!</span></p>
      </vuescrollbar>
    </div>
</div>
</template>

<script>
/* eslint no-trailing-spaces: "off" */
import Topmenu from '@/components/Topmenu.vue'
import Toplogo from '@/components/Toplogo.vue'
import Stoppuhr from '@/components/Stoppuhr.vue'
import Player from '@/components/Player.vue'
import Lautsprecher from '@/components/Lautsprecher.vue'
import Copyright from '@/components/Copyright.vue'
// import Scrollbar from 'jquery.scrollbar'
import VueScrollBar from 'vue-perfect-scrollbar'
import Hintergrundbutton from '@/components/Hintergrundbutton.vue'

window.$ = window.jQuery = require('jquery')

export default {
  name: 'Junglegeschichten',
  data () {
    return {
      who: 'Junglegeschichten',
      animateUhu: false,
      animateWasser: false
    }
  },
  components: {
    'top-menu': Topmenu,
    'top-logo': Toplogo,
    'stoppuhr': Stoppuhr,
    'player': Player,
    'lautsprecher': Lautsprecher,
    'copyright': Copyright,
    'vuescrollbar': VueScrollBar,
    'hintergrundbutton': Hintergrundbutton
  },
  watch: { 
    animateUhu: function (oldval, newval) {
      console.log('watch animateUhu', oldval, newval)
    },
    animateWasser: function (oldval, newval) {
      console.log('watch animateWasser', oldval, newval)
    }
  },
  methods: {
    aktiviereUhu () {
      console.log('aktiviereUhu')
      if (typeof window.currentAudio !== 'undefined') {
        try {
          window.currentAudio.pause()
          window.currentAudio.currentTime = 0
          window.currentAudio = undefined
        } catch(e) {
          console.log('pause geht nicht', e)
        }
      }
      window.currentAudioV = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Eule_schreit_huepft_winkt_Update.mp3')
      window.currentAudioV.muted = window.muted
      window.currentAudioV.play()
      this.animateUhu = true
      var self = this
      setTimeout(function () {
        console.log('aktiviereUhu2')
        self.animateUhu = false
      }, 3000)
    },
    aktiviereWasser () { 
      console.log('aktiviereWasser')
      window.currentAudio = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Wasserfall_rauscht_Update.mp3')
      window.currentAudio.muted = window.muted
      window.currentAudio.play()
      this.animateMaulwurf = true
      var self = this
      setTimeout(function () {
        console.log('aktiviereWasser2')
        self.animateMaulwurf = false
      }, 3000)
    }
  },
  mounted () {
    this.$ga.page(this.$router)  
    var muted = (typeof window.muted === 'undefined' ? false : window.muted)
    setTimeout(function () {
      if (typeof window.currentAudioX !== 'undefined') {
        try {
          window.currentAudioX.pause()
          window.currentAudioX.currentTime = 0
          window.currentAudioX = null
        } catch (e) {
          console.log('pause geht nicht')
        }
      }
      if (typeof window.currentAudio !== 'undefined') {
        try {
          window.currentAudio.pause()
          window.currentAudio.currentTime = 0
          window.currentAudio = null
        } catch (e) {
          console.log('pause geht nicht')
        }
      }
      window.currentAudioX = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Archivseite_Hugi_Titel_Forscher.mp3')
      window.currentAudioX.muted = muted
      window.currentAudioX.play()
      try {
          window.hintergrundSound.pause()
          window.hintergrundSound.currentTime = 0
          window.hintergrundSound = null
      } catch(e){
        console.log('hintergrundsound nicht aktiv')
      }
      window.hintergrundSound = new Audio('https://www.4korn.de/dev/HUDU_2019/audio/Hugidubies_Dschungel_Atmo_II.mp3')
      window.hintergrundSound.muted = (typeof window.muted !== 'undefined' ? window.muted : false) 
      window.hintergrundSound.loop = true
      try {
        window.hintergrundSound.play()
        window.bgsounddisabled = false
      } catch(e)  {
        window.bgsounddisabled = true
      }  
    }, 1000)
  },
  beforeDestroy () {
    try {
      window.currentAudioX.pause()
    } catch (e) {}
    try {
      window.currentAudio.pause()
    } catch (e) {}
    try {
        window.hintergrundSound.pause()
        window.hintergrundSound.currentTime = 0
        window.hintergrundSound = null
    } catch(e){
    console.log('hintergrundsound nicht aktiv')
    }
  }  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
::-webkit-scrollbar { background: none !important; }
body {margin:0; padding:0;}

/* Z-Index - Level */

.z1{z-index:10;}
.z2{z-index:20;}
.z3{z-index:30;}
.z4{z-index:40;}
.z5{z-index:50;}
.z6{z-index:60;}
.z7{z-index:70;}
.z8{z-index:80;}
.z9{z-index:90;}
.z10{z-index:100;}
.z11{z-index:110;}
.z12{z-index:120;}
.z13{z-index:130;}
.z14{z-index:140;}
.z15{z-index:150;}
.z16{z-index:160;}
.z17{z-index:170;}
.z18{z-index:180;}
.z19{z-index:190;}
.z20{z-index:200;}
.z21{z-index:210;}
.z22{z-index:220;}
.z23{z-index:230;}
.z24{z-index:240;}
.z25{z-index:250;}
.z26{z-index:260;}
.z27{z-index:270;}
.z28{z-index:280;}
.z29{z-index:290;}
.z30{z-index:300;}
.z31{z-index:310;}
.z32{z-index:320;}
.z33{z-index:330;}
.z34{z-index:340;}
.z35{z-index:350;}
.z36{z-index:360;}
.z37{z-index:370;}
.z38{z-index:380;}
.z39{z-index:390;}
.z40{z-index:400;}
.z41{z-index:410;}
.z42{z-index:420;}
.z43{z-index:430;}
.z44{z-index:440;}
.z45{z-index:450;}
.z46{z-index:460;}
.z47{z-index:470;}
.z48{z-index:480;}
.z49{z-index:490;}
.z50{z-index:500;}

/* junglegeschichten */
.junglegeschichten { position: absolute; width: 1920px; height: 1080px; bottom: 0; }

.junglegeschichten .himmel { display: block !important; }

.junglegeschichten .geschichte { position: absolute; top: 170px; left:51%;  }

.junglegeschichten .pfeil_links_big {position: absolute; left: 1vw; top: 40%;}
.junglegeschichten .pfeil_rechts_big {position: absolute; right: 1vw; top: 40%;}

/* .junglegeschichten .schwimmer {position: absolute; left: 28%; top: 39%; } */
.junglegeschichten .schwimmer {position: absolute; left: 25%; top: 12%; }
.junglegeschichten .schwimmer img{animation: schwimmer_erscheint 10s ease-out; animation-delay: 1s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center; margin-left: -870px;}
@keyframes schwimmer_erscheint {
    0% {margin-left: -870px; opacity:0;}
    25% { opacity:1;}
    100% {margin-left: 0px; opacity:1;}
}
.junglegeschichten .baer {position: absolute; /* left: 36%; top: 74%; */ left: 649px; bottom: 590px; }
.junglegeschichten .baer {animation: baer_erscheint 0.5s ease-out; animation-delay: 1s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center; /* margin-bottom: -270px; */}
@keyframes baer_erscheint {
    /* 50% {margin-bottom: -270px; transform: scale(0.5); opacity:0;}
    100% {margin-bottom: 0px; transform: scale(1); opacity:1;} */
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.junglegeschichten .kolibri {
    position: absolute;
    bottom: 228px;
    left: 36%;
}	
.junglegeschichten .kolibri img {animation: kolibri_erscheint_animation 3s ease-out; animation-delay: 1s; animation-fill-mode: forwards; transform-origin:bottom center;}
@keyframes kolibri_erscheint_animation {
    12.5% { position: absolute; top: -47px; right: 600px;}
	25% { position: absolute; top: -66px; right: 400px;}
    37.5% { position: absolute; top: -66px; right: 400px;}
	50% { position: absolute; top: -30px; right: 300px;}
	62.5% { position: absolute; top: -30px; right: 300px;}
    75% { position: absolute; top: -60px; right: 100px;}
	87.5% { position: absolute; top: -60px; right: 100px;}
    100% { position: absolute; top: -47px; right: -64px;}
}

.skigeschichten .seilbahn {position: absolute;
    left: 24%;
    bottom: 49%;
}
.junglegeschichten .gras {position: absolute; /* left:0; bottom: -5px;*/ left: -25%; bottom: -25%;}
.junglegeschichten .lianen_joe {position: absolute; left: 437px; bottom: 621px;}
.junglegeschichten .lianen_joe {animation: lianen_joe_erscheint 0.5s ease-out; animation-delay: 1.25s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center; /* margin-left: -270px; */}
@keyframes lianen_joe_erscheint {
    /* 50% {margin-left: -270px;opacity:0;}
    100% {margin-left: 0px; opacity:1;} */
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.junglegeschichten .koechin {position: absolute; left: 37%; bottom: 26%;}

.junglegeschichten .gigi {position: absolute; right: 1508px; bottom: 311px;}
.junglegeschichten .gigi {animation: gigi_erscheint 0.25s ease-out; animation-delay: 0.75s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes gigi_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}

.junglegeschichten .hugi {position: absolute; right: 1223px; bottom: 239px;}
.junglegeschichten .hugi {animation: hugi_erscheint 0.5s ease-out; animation-delay: 0.5s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes hugi_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.junglegeschichten .dubix {position: absolute; left: 763px; bottom: 223px;}
.junglegeschichten .dubix {animation: dubix_erscheint 0.75s ease-out; animation-delay: 0.75s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes dubix_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.junglegeschichten .libero {position: absolute; left: 330px; bottom: 640px;}
.junglegeschichten .libero {animation: libero_erscheint 0.5s ease-out; animation-delay: 0.25s; animation-fill-mode: forwards; opacity:0; transform-origin:bottom center;}
@keyframes libero_erscheint {
    50% { transform: scale(0.5); opacity:0;}
    100% { transform: scale(1); opacity:1;}
}
.junglegeschichten .wasserfall {position: absolute; top: -270px; left: -79px; /* left: 23%; bottom: 6%; */}
.junglegeschichten .moeve { position: absolute; top: 250px; left: 600px; }
.junglegeschichten .schild { position: absolute; bottom: 29px; left: 209px; }
.fliesstext{
    bottom: 25%;
    left: 10.5%;
    width: 79%;
    font-size: 16pt;
    font-family: 'Open Sans';
    font-weight: 400;
    position: absolute;
    overflow-y: scroll;
    overflow-x: hidden;
    height: 450px;
    padding-right: 15px;
}

/* möve animation */

@-webkit-keyframes hovering /* Safari and Chrome */ {
  from {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  to {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
@keyframes hovering {
  0% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  50% {
    -ms-transform: translate(10px,10px);
    -moz-transform: translate(10px,10px);
    -webkit-transform: translate(10px,10px);
    -o-transform: translate(10px,10px);
    transform: translate(10px,10px);
  }
  100% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
.junglegeschichten .hovering {
  -webkit-animation: hovering 5s linear infinite;
  -moz-animation: hovering 5s linear infinite;
  -ms-animation: hovering 5s linear infinite;
  -o-animation: hovering 5s linear infinite;
  animation: hovering 5s linear infinite;
}

/* schwimmer animation */
@-webkit-keyframes hovering2 /* Safari and Chrome */ {
  from {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  to {
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
@keyframes hovering2 {
  0% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
  50% {
    -ms-transform: translate(20px,0px);
    -moz-transform: translate(20px,0px);
    -webkit-transform: translate(20px,0px);
    -o-transform: translate(20px,0px);
    transform: translate(20px,0px);
  }
  100% {
    -ms-transform: translate(0,0);
    -moz-transform: translate(0,0);
    -webkit-transform: translate(0,0);
    -o-transform: translate(0,0);
    transform: translate(0,0);
  }
}
.junglegeschichten .hovering2 {
  -webkit-animation: hovering2 10s linear infinite;
  -moz-animation: hovering2 10s linear infinite;
  -ms-animation: hovering2 10s linear infinite;
  -o-animation: hovering2 10s linear infinite;
  animation: hovering2 10s linear infinite;
}

/*************** SCROLLBAR BASE CSS ***************/
 
.scroll-wrapper {
    overflow: hidden !important;
    padding: 0 !important;
    position: relative;
}
 
.scroll-wrapper > .scroll-content {
    border: none !important;
    box-sizing: content-box !important;
    height: auto;
    left: 0;
    margin: 0;
    max-height: none;
    max-width: none !important;
    overflow: scroll !important;
    padding: 0;
    position: relative !important;
    top: 0;
    width: auto !important;
}
 
.scroll-wrapper > .scroll-content::-webkit-scrollbar {
    height: 0;
    width: 0;
}
 
.scroll-element {
    display: none;
}
.scroll-element, .scroll-element div {
    box-sizing: content-box;
}
 
.scroll-element.scroll-x.scroll-scrollx_visible,
.scroll-element.scroll-y.scroll-scrolly_visible {
    display: block;
}
 
.scroll-element .scroll-bar,
.scroll-element .scroll-arrow {
    cursor: default;
}
 
.scroll-textarea {
    border: 1px solid #cccccc;
    border-top-color: #999999;
}
.scroll-textarea > .scroll-content {
    overflow: hidden !important;
}
.scroll-textarea > .scroll-content > textarea {
    border: none !important;
    box-sizing: border-box;
    height: 100% !important;
    margin: 0;
    max-height: none !important;
    max-width: none !important;
    overflow: scroll !important;
    outline: none;
    padding: 2px;
    position: relative !important;
    top: 0;
    width: 100% !important;
}
.scroll-textarea > .scroll-content > textarea::-webkit-scrollbar {
    height: 0;
    width: 0;
}
 
/*************** SIMPLE INNER SCROLLBAR ***************/
 
.scrollbar-inner > .scroll-element,
.scrollbar-inner > .scroll-element div
{
    border: none;
    margin: 0;
    padding: 0;
    position: absolute;
    z-index: 10;
}
 
.scrollbar-inner > .scroll-element div {
    display: block;
    height: 100%;
    left: 0;
    top: 0;
    width: 100%;
}
 
.scrollbar-inner > .scroll-element.scroll-x {
    bottom: 2px;
    height: 8px;
    left: 0;
    width: 100%;
}
 
.scrollbar-inner > .scroll-element.scroll-y {
    height: 100%;
    right: 2px;
    top: 0;
    width: 8px;
}
 
.scrollbar-inner > .scroll-element .scroll-element_outer {
    overflow: hidden;
}
 
.scrollbar-inner > .scroll-element .scroll-element_outer,
.scrollbar-inner > .scroll-element .scroll-element_track,
.scrollbar-inner > .scroll-element .scroll-bar {
    -webkit-border-radius: 8px;
    -moz-border-radius: 8px;
    border-radius: 8px;
}
 
.scrollbar-inner > .scroll-element .scroll-element_track,
.scrollbar-inner > .scroll-element .scroll-bar {
    -ms-filter:"progid:DXImageTransform.Microsoft.Alpha(Opacity=40)";
    filter: alpha(opacity=40);
    opacity: 0.4;
}
 
.scrollbar-inner > .scroll-element .scroll-element_track { background-color: #e0e0e0; }
.scrollbar-inner > .scroll-element .scroll-bar { background-color: #c2c2c2; }
.scrollbar-inner > .scroll-element:hover .scroll-bar { background-color: #919191; }
.scrollbar-inner > .scroll-element.scroll-draggable .scroll-bar { background-color: #919191; }

/* update scrollbar offset if both scrolls are visible */
 
.scrollbar-inner > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_track { left: -12px; }
.scrollbar-inner > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_track { top: -12px; }

.scrollbar-inner > .scroll-element.scroll-x.scroll-scrolly_visible .scroll-element_size { left: -12px; }
.scrollbar-inner > .scroll-element.scroll-y.scroll-scrollx_visible .scroll-element_size { top: -12px; }

::-webkit-scrollbar {
    width: 15px;
}
 
::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0px #ac8a69; 
    box-shadow: inset 0 0 0px #ac8a69; 
    -webkit-border-radius: 0;
    border-radius: 0;
}
 
::-webkit-scrollbar-thumb {
    -webkit-border-radius: 10px;
    border-radius: 10px;
    background: #ac8a69; 
}
::-webkit-scrollbar-thumb:window-inactive {
    background: #ac8a69; 
}
::-webkit-scrollbar-button {
    background: none;
}
::-webkit-scrollbar-button:start:decrement,
::-webkit-scrollbar-button:end:increment {
  height: 20px;
  width: 20px;
  display: none;
  background-repeat: no-repeat; 
}

.wasserfall_animation {
  width: 446px;
  height: 1621px;
  background: url('/static/assets/junglegeschichten/Wasserfall_Animation.png') top center;
  animation-delay: 2s;
  animation: wasserfall_animation 1s steps(4) infinite;
  transform: scale(1);
  margin-top: 0px;
}

@keyframes wasserfall_animation {
    100% { background-position: 0 -6484px; }
}
.Uhu {
    position: absolute;
    top: 120px;
    left: 720px;
  cursor:pointer;
    width: 163px;
  height: 182px;
    margin-top: 0px;
  background: url('/static/assets/junglegeschichten/Uhu_Animation.png') top center;
}
.uhu_animation {
  animation-delay: 1s;
  animation: uhu_animation 3s steps(9) infinite;
  transform: scale(1);
  }

@keyframes uhu_animation {
    100% { background-position: 0 -1638px; }
}	
.junglegeschichten .player {position: absolute!important; left: 130px!important;}
.pointer{cursor:pointer;}
span { font-family: FrozenMemory; }
.geschichte .player { top: 654px !important; }
</style>



// WEBPACK FOOTER //
// src/components/Junglegeschichten.vue